import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { setAuthToken } from "@/App";
import { 
  LayoutDashboard, 
  Target, 
  Hash, 
  BarChart3, 
  LogOut,
  Trash2,
  User,
  Type,
  Users,
  UserCog,
  Tags,
  MailCheck,
  Send,
  RefreshCw
} from "lucide-react";

export default function Sidebar({ userRole = "owner" }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    setAuthToken(null);
    window.location.href = "/login";
  };

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: "/app", icon: LayoutDashboard, label: "Dashboard", testId: "nav-dashboard" },
    { path: "/lotteries", icon: Target, label: "Lotteries", testId: "nav-lotteries" },
    { path: "/brands", icon: Tags, label: "Brands", testId: "nav-brands" },
    { path: "/recipients", icon: MailCheck, label: "Recipients", testId: "nav-recipients" },
    { path: "/email-queue", icon: Send, label: "Email Queue", testId: "nav-email-queue" },
    { path: "/number-assets", icon: Hash, label: "Number Assets", testId: "nav-number-assets" },
    { path: "/custom-fonts", icon: Type, label: "Custom Fonts", testId: "nav-custom-fonts" },
    { path: "/trash", icon: Trash2, label: "Trash", testId: "nav-trash" },
    { path: "/analytics", icon: BarChart3, label: "Analytics", testId: "nav-analytics" },
  ];

  // Only owners can see Team management
  if (userRole === "owner") {
    navItems.push({ path: "/team", icon: Users, label: "Team", testId: "nav-team" });
    navItems.push({ path: "/users", icon: UserCog, label: "Users", testId: "nav-users" });
  }

  return (
    <aside className="w-64 bg-[#12121a] border-r border-white/5 flex flex-col h-screen sticky top-0">
      <div className="p-6 border-b border-white/5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#10B981] to-[#059669] flex items-center justify-center">
            <RefreshCw className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-white text-lg">BannerSync</h1>
            <p className="text-xs text-gray-500">bannersync.co.uk</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map(({ path, icon: Icon, label, testId }) => (
          <Button
            key={path}
            variant="ghost"
            className={`w-full justify-start ${
              isActive(path)
                ? "text-white bg-white/5 hover:bg-white/10"
                : "text-gray-400 hover:text-white hover:bg-white/5"
            }`}
            onClick={() => navigate(path)}
            data-testid={testId}
          >
            <Icon className="w-4 h-4 mr-3" />
            {label}
          </Button>
        ))}
      </nav>

      <div className="p-4 border-t border-white/5 space-y-1 mt-auto">
        <Button
          variant="ghost"
          className={`w-full justify-start ${
            isActive("/profile")
              ? "text-white bg-white/5 hover:bg-white/10"
              : "text-gray-400 hover:text-white hover:bg-white/5"
          }`}
          onClick={() => navigate("/profile")}
          data-testid="nav-profile"
        >
          <User className="w-4 h-4 mr-3" />
          Profile
        </Button>
        <Button
          variant="ghost"
          className="w-full justify-start text-gray-400 hover:text-red-400 hover:bg-red-500/10"
          onClick={handleLogout}
          data-testid="logout-button"
        >
          <LogOut className="w-4 h-4 mr-3" />
          Logout
        </Button>
      </div>
    </aside>
  );
}
